var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enableRecaptcha
    ? _c(
        "div",
        [
          _c(
            "v-form",
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-card",
                    {
                      class: _vm.gR.class,
                      attrs: { "min-width": "90%", outlined: true }
                    },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "3" } },
                                [
                                  _c("v-expand-transition", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.gR.init.btnVisible,
                                            expression: "gR.init.btnVisible"
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            class: _vm.gR.class,
                                            attrs: { fab: "", elevation: "0" },
                                            on: { click: _vm.onSubmit }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                " mdi-checkbox-blank-outline "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-expand-transition", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.gR.ok.btnVisible,
                                            expression: "gR.ok.btnVisible"
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            class: _vm.gR.class,
                                            attrs: { fab: "", elevation: "0" },
                                            on: { click: _vm.resetRecaptcha }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v(
                                                " mdi-account-check-outline "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-expand-transition", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.gR.error.btnVisible,
                                            expression: "gR.error.btnVisible"
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            class: _vm.gR.class,
                                            attrs: { fab: "", elevation: "0" },
                                            on: { click: _vm.resetRecaptcha }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v(" mdi-alert ")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("v-expand-transition", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.gR.progress.btnVisible,
                                            expression: "gR.progress.btnVisible"
                                          }
                                        ]
                                      },
                                      [
                                        _c("v-btn", {
                                          class: _vm.gR.class,
                                          attrs: {
                                            fab: "",
                                            elevation: "0",
                                            loading: _vm.gR.progress.btnVisible
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: { cols: "9", "align-self": "center" }
                                },
                                [
                                  _c(
                                    "v-expand-transition",
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.gR.init.msgVisible,
                                              expression: "gR.init.msgVisible"
                                            }
                                          ],
                                          class: _vm.gR.class
                                        },
                                        [
                                          _vm._v(
                                            " Por favor, confirme que você é um eleitor. "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expand-transition",
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.gR.ok.msgVisible,
                                              expression: "gR.ok.msgVisible"
                                            }
                                          ],
                                          class: _vm.gR.class
                                        },
                                        [
                                          _vm._v(
                                            " Verificação concluída com sucesso! "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expand-transition",
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.gR.error.msgVisible,
                                              expression: "gR.error.msgVisible"
                                            }
                                          ],
                                          class: _vm.gR.class
                                        },
                                        [
                                          _vm._v(
                                            " Atenção! Não foi possível validar o eleitor. "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expand-transition",
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.gR.exError.msgVisible,
                                              expression:
                                                "gR.exError.msgVisible"
                                            }
                                          ],
                                          class: _vm.gR.class
                                        },
                                        [
                                          _vm._v(
                                            " Validação Necessária: Por favor, confirme que você é um eleitor. "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expand-transition",
                                    [
                                      _c(
                                        "v-sheet",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.gR.progress.msgVisible,
                                              expression:
                                                "gR.progress.msgVisible"
                                            }
                                          ],
                                          class: _vm.gR.class
                                        },
                                        [_vm._v(" Validando... ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }